import { Skeleton, Button } from '@radix-ui/themes';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import type { ClubMemberType } from 'types/club';
import PlayerUserObject from './PlayerUserObject';

export const ClubMembers: React.FC<{
  clubMembersList?: ClubMemberType[];
  members_counter?: number;
  loading: boolean;
  listName: string;
  id?: number;
  twoColumns?: boolean;
}> = ({ clubMembersList, loading, members_counter, listName, id, twoColumns = false }) => (
  <div
    id='container'
    className='border-neutral-neutral-2 bg-neutral-neutral-1 flex flex-col items-start gap-2 self-stretch rounded-2xl border border-solid p-3'
  >
    {members_counter && (
      <div id='topbar' className='flex items-center justify-between gap-2 self-stretch'>
        <div className='text-neutral-neutral-12 self-stretch text-lg font-medium tracking-tight'>
          {listName} ({members_counter})
        </div>
        {id && (
          <Link className='flex self-end' to={`/circolo/${id}/membri`}>
            <Button variant='outline' size='2' className='cursor-pointer'>
              Vedi tutti
            </Button>
          </Link>
        )}
      </div>
    )}
    <div
      id='content'
      className='text-neutral-neutral-12 flex-1 items-center justify-between gap-2 self-stretch text-sm font-normal'
    >
      <div id='table' className='w-full flex-wrap items-start gap-2 self-stretch'>
        <div
          id='members'
          className='border-neutral-neutral-2 text-neutral-neutral-alpha-12 flex justify-between gap-2 self-stretch rounded-xl border border-solid bg-white p-3 text-base font-bold tracking-tighter'
        >
          <Skeleton loading={loading} className='h-auto w-auto'>
            <div className={classNames('grid w-full grid-cols-1 gap-2', { 'xl:grid-cols-2': twoColumns })}>
              {clubMembersList?.map((member) => (
                <div
                  key={member.id}
                  className='border-neutral-neutral-2 bg-neutral-neutral-1 rounded-2xl border border-solid'
                >
                  <PlayerUserObject showRole={false} key={member.id} {...member} />
                </div>
              ))}
            </div>
          </Skeleton>
        </div>
      </div>
    </div>
  </div>
);

export default ClubMembers;
